import request from '@/axios'

// 菜单查询
export const menuSearch = (data: object) => {
  return request.post({ url: '/menu/search', data, hideLoading: true })
}

// 删除菜单历史查询记录
export const menuDeleteSearchRecord = (data: object) => {
  return request.post({ url: '/menu/delSearchRecord', data })
}

// 快捷入口：历史记录&收藏记录查询
export const menuQuickStart = (data: object) => {
  return request.post({ url: '/menu/quickAccess', data })
}

// 菜单访问上报
export const menuUpMenuAccess = (data: object) => {
  return request.post({ url: '/menu/upMenuAccess', data })
}

// 收藏菜单
export const menuFavorite = (data: object) => {
  return request.post({ url: '/menu/favorite', data })
}

// 取消收藏菜单
export const menuUnfavorite = (data: object) => {
  return request.post({ url: '/menu/unfavorite', data })
}
